import React from 'react'
import { useNavigate } from 'react-router-dom';
import { Bootstrap } from 'react-bootstrap-icons';
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom';
import { BagFill, CartFill, CreditCard, PatchCheckFill, CartPlusFill } from 'react-bootstrap-icons';
import Footer from './footer';
import './ViewCart.css'
import { auth, logInWithEmailAndPassword, signInWithGoogle, signInWithFacebook, signInWithTwitter } from "./Firebase";
import { getAuth } from "firebase/auth";

export default function ViewCart() {
  const cartItems = useSelector(state => state.cartReducer.cartItems);
  const Total = useSelector(state => state.cartReducer.total);
  const navigate = useNavigate();
  const auth1 = getAuth();
  const user = auth1.currentUser;
  auth1.onAuthStateChanged((user)=>{
    if(!user){
      navigate('/login')
    }
  })
  if(Total == 0){
    return(
      <div className='my-5'>
      <hr className='my-5' style={{visibility: "hidden"}}></hr>
      <div className='my-5'
       style={{display: "flex",flexDirection: "column",justifyContent: "center", alignItems: "center",padding: "4%",color: "white"}}>
        <CartPlusFill style={{fontSize: "5rem", color: "green"}}></CartPlusFill>
        <h1 className='my-3'>Your Cart is empty</h1>
        <h3>Make yourself Happy by purchasing Something</h3>
        <Link to='/shop' className='btn newsletter-btn my-3'>Continue Shopping</Link>
      </div>
      </div>
    )
  }
  return (
    <div className='mt-5 col-md-12 CartMainDiv' style={{top: "0",bottom: "0",height: "100%",zIndex: "-1"}}>
      <hr className='my-5' style={{visibility: "hidden",paddingBottom: "3%"}}></hr>
      <div className="CartApp my-5">
      <div className="section col-12 col-md-3">
        {/* <div className="line"></div> */}
        <div className="content CartIcons" >
          <div className='container'>
            <div className='circleIcons'>
            <p style={{ display: "flex", alignItems: "center", fontSize: "1.5rem"  }} className="p-3">
            <BagFill style={{ color: "white" }} ></BagFill>
          </p>
            </div>
            <div className='lineIcons'></div>
            <div className='circleIcons'>
            <p style={{ display: "flex", alignItems: "center", fontSize: "1.5rem",  }} className="p-3" >
            <CartFill style={{ color: "white" }}></CartFill>
          </p>
            </div>
            <div className='lineIcons'></div>
            <div className='circleIcons'>
            <p style={{ display: "flex", alignItems: "center", fontSize: "1.5rem" }} className="p-3">
            <CreditCard style={{ color: "white" }}></CreditCard>
          </p>
            </div>
          </div>
        </div>
        <div className="line"></div>
      </div>
      <div className="section col-12 col-md-6 my-2">
        <div className="line"></div>
        <div className="content" style={{padding: "0 5%"}}>
          <h1 style={{ color: "white" }}>Cart</h1>
          <table className="table mb-5 table-striped table-hover" style={{ color: "white"}}>
            <thead>
              <tr style={{color: "white"}}>
                <th scope='col'></th>
                <th scope="col">Name</th>
                <th scope="col">Quantity</th>
                <th scope="col">Price</th>
              </tr>
            </thead>
            <tbody>
              {cartItems.length ?
                cartItems.map(item => (
                  <tr key={item.id} style={{color: "white"}}>
                    <td><img src={item.image} height="50px" width='auto' /></td>
                    <td style={{color: "white"}}>{item.title}</td>
                    <td style={{color: "white"}}>{item.quantity}</td>
                    <td style={{color: "white"}}>
                      {item.discountedPrice ? `$${item.discountedPrice}` : `$${item.price}`}
                      </td>
                  </tr>
                )) :
                <tr style={{color: "white"}}>
                  <td style={{color: "white"}}>Your cart is empty</td>
                  <td style={{color: "white"}}>-</td>
                  <td style={{color: "white"}}>-</td>
                  <td style={{color: "white"}}>0</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
        <div className="line"></div>
      </div>
      <div className="section col-12 col-md-3">
        <div className="line"></div>
        <div className="content col-12 col-md-3">
        <h1>Cart Totals</h1>
          <h3>Subtotal: {Math.round(Total)}</h3>
          <h3>Total: {Math.round(Total)}</h3>
          <Link to='/checkout-details' className='btn newsletter-btn'  >Proceed to Pay</Link>
        </div>
        <div className="line"></div>
      </div>
    </div>
    </div>
  )
}
